import React, { Fragment, useState, useEffect } from "react";
import { set_page_state } from "../../redux/actions/PageStateAction";
import { set_store } from "../../redux/actions/CreateStoreAction";
import { set_user } from "../../redux/actions/AuthAction";
import { connect } from "react-redux";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";
import { Redirect } from "react-router";
import { ReactComponent as Home } from "./images/home.svg";
import { ReactComponent as Store } from "./images/store.svg";
import { ReactComponent as Building } from "./images/building.svg";
import { ReactComponent as Building1 } from "./images/building-1.svg";
import { ReactComponent as Account } from "./images/account-login.svg";
import Logo from "../../assets/images/logo.png";
import "./createstore.scss";
import BankForm from "../../pages/createStorepage/forms/bankform/BankForm";
import CountryForm from "../../pages/createStorepage/forms/countryform/CountryForm";
import VATForm from "../../pages/createStorepage/forms/vatform/VATForm";
import DocumentForm from "../../pages/createStorepage/forms/documentform/DocumentForm";
import StoreForm from "../../pages/createStorepage/forms/storeform/StoreForm";
import LoginForm from "../../pages/createStorepage/forms/loginform/LoginForm";
import TermsAndConditionsForm from "../../pages/createStorepage/forms/terms_and_conditionsform/TermsAndConditionsForm";

const CreateStore = (props) => {
  const [goBack, setGoBack] = useState(false);
  const [goBackToDashboard, setGoBackToDashboard] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Create Store";
  }, []);

  useEffect(() => {
    setGoBack(false);
    if (localStorage.getItem("access_token")) {
      apiJson.auth.validateToken().then((response) => {
        if (response.success) {
          localStorage.setItem(
            "access_token",
            response.headers["access-token"]
          );
          localStorage.setItem("client", response.headers.client);
          localStorage.setItem("uid", response.headers.uid);
          props.set_user({
            isSignedIn: true,
            user: response.data.data,
          });
          // if (response?.data?.data?.has_store) {
          //   props.set_page_state({ pageState: { id: 1 } });
          //   props.set_store({ store: {} });
          //   setGoBackToDashboard(true);
          // }
        } else {
          if (parseInt(response.status) === 401) {
            props.set_user({ isSignedIn: false, user: {} });
            localStorage.clear();
            // eslint-disable-next-line
            message = "Unauthorized Access";
            showError();
            props.set_page_state({ pageState: { id: 1 } });
            props.set_store({ store: {} });
            document.cookie =
              "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
            setGoBack(true);
          }
        }
      });
    } else {
      document.cookie =
        "authHeaders=undefined; expires= Thu, 21 Aug 2014 20:00:00 UTC";
      props.set_page_state({ pageState: { id: 1 } });
    }
  }, [props.pageState?.id]);

  const selectedClass = (step) => {
    return props.pageState?.id === step ? "selected" : "";
  };
  return (
    <Fragment>
      <div className="create-store-desktop">
        <div className="row gx-0 create-store-row flex-column align-items-center mx-auto">
          <div className="logo-col mx-auto">
            <img src={Logo} width="100%" height="60px" alt="" />
          </div>
          <div className="header-text-col mx-auto">Create a Store</div>
          <div className="navigation-col d-flex justify-content-between align-items-center mx-auto">
            <div
              className={`${selectedClass(
                1
              )} login navigation-link d-flex justify-content-center align-items-center`}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Account />
              </div>
              <span className="link-text">SignUp</span>
            </div>
            {/* <div
              onClick={() => {
                props.pageState?.id >= 2 &&
                  props.set_page_state({ pageState: { id: 2 } });
              }}
              className={`${selectedClass(2)} ${
                props.pageState?.id >= 2 ? "pointer" : ""
              } country navigation-link d-flex justify-content-center align-items-center`}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Home />
              </div>
              <span className="link-text">Country</span>
            </div> */}
            <div
              onClick={() => {
                props.pageState?.id >= 2 &&
                  props.set_page_state({ pageState: { id: 2 } });
              }}
              className={`${selectedClass(2)} ${
                props.pageState?.id >= 2 ? "pointer" : ""
              } store navigation-link d-flex justify-content-center align-items-center`}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Store />
              </div>
              <span className="link-text">Store</span>
            </div>
            <div
              onClick={() => {
                props.pageState?.id >= 3 &&
                  props.set_page_state({ pageState: { id: 3 } });
              }}
              className={`${selectedClass(3)} ${
                props.pageState?.id >= 3 ? "pointer" : ""
              } documents navigation-link  d-flex justify-content-center align-items-center`}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Store />
              </div>
              <span className="link-text">Document</span>
            </div>
            <div
              onClick={() => {
                props.pageState?.id >= 4 &&
                  props.set_page_state({ pageState: { id: 4 } });
              }}
              className={`${selectedClass(4)} ${
                props.pageState?.id >= 4 ? "pointer" : ""
              } bank navigation-link d-flex justify-content-center align-items-center `}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Building />
              </div>
              <span className="link-text">Bank</span>
            </div>
            <div
              onClick={() => {
                props.pageState?.id >= 5 &&
                  props.set_page_state({ pageState: { id: 5 } });
              }}
              className={`${selectedClass(5)} ${
                props.pageState?.id >= 5 ? "pointer" : ""
              }vat navigation-link  d-flex justify-content-center align-items-center `}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Building1 />
              </div>
              <span className="link-text">Vat</span>
            </div>
            <div
              onClick={() => {
                props.pageState?.id >= 6 &&
                  props.set_page_state({ pageState: { id: 6 } });
              }}
              className={`${selectedClass(6)} ${
                props.pageState?.id >= 6 ? "pointer" : ""
              }vat navigation-link  d-flex justify-content-center align-items-center `}
            >
              <div className="svg-container d-flex justify-content-center align-items-center">
                <Building1 />
              </div>
              <span className="link-text">Terms and conditions</span>
            </div>
          </div>
          <div className="form-col mx-auto d-flex flex-column">
            {props.pageState?.id === 1 ? (
              <LoginForm />
            ) : props.pageState?.id === 2 ? (
              // <CountryForm />
              <StoreForm />
            // ) : props.pageState?.id === 3 ? (
            //   <StoreForm />
            ) : props.pageState?.id === 3 ? (
              <DocumentForm />
            ) : props.pageState?.id === 4 ? (
              <BankForm />
            ) : props.pageState?.id === 5 ? (
              <VATForm />
            ) : (
              props.pageState?.id === 6 && <TermsAndConditionsForm />
            )}
          </div>
        </div>
      </div>
      {goBack && <Redirect to="/" />}
      {goBackToDashboard && <Redirect to="/vendor" />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pageState: state.pageState.pageState,
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_page_state, set_store, set_user };

export default connect(mapStateToProps, mapDispatchTopProps)(CreateStore);
